import React, {Component} from 'react';
import './App.css';
import './Spinner.css';

const Spinner = () => <div className="spinner" />;

if (!Object.values)
    Object.values = o => Object.keys(o).map(k => o[k]);

const interleave = (deck) => {
    const len  = deck.length,
          stop = Math.floor(len / 2);
    for (let i = 0; i < stop; i+=2)
        [deck[i], deck[len-1 - i]] = [deck[len-1 - i], deck[i]];

    return deck;
};

class App extends Component {
    constructor() {
        super();
        this.state = {
            images: {},
        };
    }

    componentDidMount() {
        fetch('/wp-json/west/product-images')
            .then(results => results.json())
            .then(results => {
                const len  = Object.keys(results).length,
                      sqrt = Math.sqrt(len);

                if (len > 0 && sqrt % 1 === 0) // is a perfect square
                    return results;

                return fetch('/wp-json/west/front-page-images')
                    .then(results => results.json())
                    .then(stockImages => {
                        // number of stock images needed to get a square
                        const n = (Math.ceil(sqrt) ** 2) - len;

                        // Start at 900 to avoid id collisions. Changing this
                        // will require changing the endpoint in rest.php
                        for (let i = 900; i < 900 + n; i++)
                            results[i] = stockImages[i];

                        return results;
                    }).catch(console.log.bind(console));
            })
            .then(obj => { // Shuffle the category/stock images around
                let i = 0, images = {};
                interleave(Object.keys(obj)).map(id => images[i++] = obj[id]);
                return images;
            })
            .then(images => this.setState({images}))
            .then(() => setInterval(() => this.forceUpdate(), 5000))
            .catch(console.log.bind(console));
    }

    render() {
        if (!Object.keys(this.state.images).length)
            return <Spinner />;

        const k      = Object.keys(this.state.images),
              len    = k.length,
              sqrt   = Math.sqrt(len),
              n      = ((Math.random() * sqrt + 1) | 0) - 1; // n ∊ [0..sqrt-1]
        let   chosen = [];

        for (let i = 0; i < n; i++)
            chosen[i] = k[len * Math.random() | 0];

        return (
            <div className="App">
                <div className="product-container">
                    {
                        Object.keys(this.state.images).map(id =>
                            <div
                                className="product-image"
                                key={id}
                                style={{
                                    width:         (100/sqrt) + '%',
                                    paddingBottom: (100/sqrt) + '%',
                                    background:    `#FFF url( ${this.state.images[id].img} ) 0% 0% / cover`,
                                    opacity:       (chosen.indexOf(id) > -1) ? 0.35 : 1.0,
                                }}
                            />
                        )
                    }
                </div>
            </div>
        );
    }
}

export default App;
